"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToZonedTimezone = transformDateToZonedTimezone;
const date_fns_tz_1 = require("date-fns-tz");
const getAdjustedTimezone_1 = require("../helpers/getAdjustedTimezone");
function transformDateToZonedTimezone(date, timezone) {
    const adjustedTimezone = (0, getAdjustedTimezone_1.getAdjustedTimezone)(timezone);
    return (0, date_fns_tz_1.formatInTimeZone)(date, adjustedTimezone, "O");
}
//# sourceMappingURL=transformDateToZonedTimezone.js.map